import { render, staticRenderFns } from "./MblmRender.vue?vue&type=template&id=15cbf7b4&scoped=true"
import script from "./MblmRender.vue?vue&type=script&lang=js"
export * from "./MblmRender.vue?vue&type=script&lang=js"
import style0 from "./MblmRender.vue?vue&type=style&index=0&id=15cbf7b4&prod&lang=less&scoped=true"
import style1 from "./MblmRender.vue?vue&type=style&index=1&id=15cbf7b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbf7b4",
  null
  
)

export default component.exports